module.exports = __webpack_public_path__ + "assets/img/my-icon-03.42c037a6.png";